import { render, staticRenderFns } from "./WifiStatusTable.vue?vue&type=template&id=a5bb38d4&scoped=true&"
import script from "./WifiStatusTable.vue?vue&type=script&lang=js&"
export * from "./WifiStatusTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5bb38d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
